import { DesignSystemPrimitive } from 'designSystem/types';
import { resolveTokenValue } from 'designSystem/tokens/resolver';
import * as S from './styles';

interface ButtonPrimitivePreviewProps {
	primitive: DesignSystemPrimitive;
}

export const ButtonPrimitivePreview = ({ primitive }: ButtonPrimitivePreviewProps) => {
	// Extract key properties for button preview
	const getButtonText = () => {
		if (primitive.baseSelector.includes('primary')) return 'Primary';
		if (primitive.baseSelector.includes('secondary')) return 'Secondary';
		if (primitive.baseSelector.includes('ghost')) return 'Ghost';
		if (primitive.baseSelector.includes('text')) return 'Text';
		return 'Button';
	};

	// Create inline styles from CSS properties, resolving token references
	const inlineStyles: React.CSSProperties = {};
	primitive.properties.forEach((prop) => {
		const cssProp = prop.name.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
		const resolvedValue = resolveTokenValue(prop.value);
		if (cssProp === 'background' || cssProp === 'backgroundColor') {
			inlineStyles.background = resolvedValue;
		} else if (cssProp === 'color') {
			inlineStyles.color = resolvedValue;
		} else if (cssProp === 'borderRadius') {
			inlineStyles.borderRadius = resolvedValue;
		} else if (cssProp === 'border' || cssProp === 'borderColor') {
			inlineStyles.border = resolvedValue;
		} else if (cssProp === 'padding') {
			inlineStyles.padding = resolvedValue;
		}
	});

	return (
		<S.PrimitivePreview>
			<button
				style={{
					...inlineStyles,
					cursor: 'default',
					fontSize: '12px',
					minWidth: '80px',
					whiteSpace: 'nowrap',
				}}
			>
				{getButtonText()}
			</button>
		</S.PrimitivePreview>
	);
};
